import { z } from 'zod'

/**
 * One student's awarded amount on a purse, exactly as ServiceNow supplied it. The platform never
 * derives these numbers, so a student missing from a purse's list simply has nothing to fund there.
 */
export const PurseAwardStudentSchema = z.object({
  student_id: z.number(),
  student_name: z.string(),
  amount_awarded: z.coerce.number(),
})

/** What a single purse would pay out for the requested students. */
export const PurseAwardSchema = z.object({
  program_purse_id: z.number(),
  program_purse_name: z.string(),
  students_count: z.number(),
  total_amount: z.coerce.number(),
  students: z.array(PurseAwardStudentSchema),
})

export const StudentAwardPreviewResultSchema = z.object({
  program_id: z.number(),
  total_students_requested: z.number(),
  total_planned_amount: z.coerce.number(),
  purse_awards: z.array(PurseAwardSchema),
})

export type PurseAwardStudent = z.infer<typeof PurseAwardStudentSchema>
export type PurseAward = z.infer<typeof PurseAwardSchema>
export type StudentAwardPreviewResult = z.infer<
  typeof StudentAwardPreviewResultSchema
>
